

import React from "react";
import { CableCar3 } from "../../../icons/CableCar3";
import { CalendarHeart } from "../../../icons/CalenderHeart";
import { Dumbbell } from "../../../icons/Dumbbell";
import { Martini } from "../../../icons/Martini";
import { UtensilsCrossed4 } from "../../../icons/UtensilsCrossed4";
import "./style.css";
import { Gift1 } from "../../../icons/Gift1";

export const ActivityType = ({ variant, className,text,Icon }) => {
  return (
    <div
      className={`activity-type ${className}`}
    >
      {variant === "perks" && <Gift1 className="instance-node" />}

{variant === "dining" && <UtensilsCrossed4 className="instance-node  dining-icon" />}

{["dining", "perks"].includes(variant) && (
  <div className="div">
    {variant === "perks" && <>Offers</>}

    {variant === "dining" && <>Dining</>}
  </div>
)}

{variant === "events" && (
  <>
    <CalendarHeart className="instance-node" />
    <div className="div">Events</div>
  </>
)}

{variant === "nightlife" && (
  <>
    <Martini className="instance-node" />
    <div className="div">Nightlife</div>
  </>
)}

{variant === "health" && (
  <>
    <Dumbbell className="instance-node" />
    <div className="div">Health</div>
  </>
)}

      {variant === "activities" && (
        <>
          <CableCar3 className="!relative !w-4 !h-4" />
          <div className="relative w-fit font-secondary font-medium text-white text-xs tracking-[0] leading-[13.8px] whitespace-nowrap">
            Activities
          </div>
        </>
      )}

{variant === "default" && (
        <>
          {/* <CableCar3 className="!relative !w-4 !h-4" /> */}
          {Icon && Icon}
          <div className="relative w-fit font-secondary font-medium text-white text-xs tracking-[0] leading-[13.8px] whitespace-nowrap icon-css">
            {text }
          </div>
        </>
      )}
    </div>
  );
};
